
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { Routes, provideRouter, PreloadAllModules, withPreloading } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { authGuard } from './services/auth/auth.guard';
import { HomeComponent } from './pages/home/home.component';
import { MastersComponent } from './pages/home/masters/masters.component';
import { DashboardComponent } from './pages/home/masters/dashboard/dashboard.component';
import { FinanceComponent } from './pages/home/finance/finance.component';
import { TransactionComponent } from './pages/home/transaction/transaction.component';
import {DeliverychallanComponent} from "./pages/home/deliverychallan/deliverychallan.component"
import { ReportsComponent } from './pages/home/reports/reports.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { ComplaintAttendanceComponent } from './pages/home/complaint-attendance/complaint-attendance.component';
import { roleGuard } from './services/role/role.guard';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { DashboardLandingComponent } from './pages/home/masters/landing-dashboard-page/dashboard_landing';
export const routes: Routes = [
    {
        path: '',
        redirectTo: localStorage.getItem('authUser') 
        ? 
        '/welcome'
        : 
        '/login',
        pathMatch: 'full',
      },
    { path: 'login', component: LoginComponent },
    
    { 
        path: 'forget/password', 
        component: ForgotPasswordComponent,  
        // data: { pagename: 'Forgot Password'}, 
        // canActivate: [authGuard, roleGuard],
    },
    {
        path: '',
        component: HomeComponent,
        canActivate: [authGuard],
        data: { pagename: 'Dashboard'},
        children: [
           {
                path: 'welcome',
                canActivate: [authGuard],
                component: DashboardLandingComponent,
                loadChildren: () => import("./pages/home/home.routes").then((x) => x.homeRoutes),
            },
            {
                path: 'dashboard',
                canActivate: [authGuard],
                component: DashboardComponent,
                data: { pagename: 'Dashboard'},
                loadChildren: () => import("./pages/home/home.routes").then((x) => x.homeRoutes),
            },
            {
                path: 'masters',
                canActivate: [authGuard],
                component: MastersComponent,
                loadChildren: () => import("./pages/home/masters/masters.routes").then((x) => x.mastersRoutes),
            },
            {
                path: 'finance',
                canActivate: [authGuard],
                component: FinanceComponent,
                loadChildren: () => import("./pages/home/finance/finance.routes").then((x) => x.financeRoutes),
            },
            {
                path: 'transaction',
                canActivate: [authGuard],
                component: TransactionComponent,
                loadChildren: () => import("./pages/home/transaction/transaction.routes").then((x) => x.transactionRoutes),
            },
            {
                path: 'reports',
                canActivate: [authGuard],
                component:ReportsComponent,
                loadChildren: () => import("./pages/home/reports/reports.routes").then((x) => x.reportsRoutes),
            },
            {
                path: 'deliverychallan',
                canActivate: [authGuard],
                component:DeliverychallanComponent,
                loadChildren: () => import("./pages/home/home.routes").then((x) => x.homeRoutes),
            },
            {
                path: 'complaint-attendance',
                canActivate: [authGuard],
                component:ComplaintAttendanceComponent,
                loadChildren: () => import("./pages/home/complaint-attendance/complaintAttendance.routes").then((x) => x.complaintAttendanceRoutes),
            },
            { 
                path: 'unauthorized', 
                component: UnauthorizedComponent 
            },
            { path: '**', component: NotFoundComponent }
            
            
        ]
    }
];

export const appConfig: ApplicationConfig = {
    providers: [
      provideRouter(routes, withPreloading(PreloadAllModules)), // Enables preloading
    ],
  };